import { Check, Heart, ListMusic, ListPlus, ListStart, Plus, Share2 } from 'lucide-react'
import type { TrackRowMenuItem } from './TrackRow'

export interface SongActions {
  share?: () => void
  shareLabel?: string
  playNext?: () => void
  addToQueue?: () => void
  addToPlaylist?: () => void
  addToLibrary?: () => void
  inLibrary?: boolean
  toggleFavorite?: () => void
  favorite?: boolean
  playbackDisabled?: boolean
  busy?: boolean
}

export function songActions(actions: SongActions): TrackRowMenuItem[] {
  const items: TrackRowMenuItem[] = []
  if (actions.playNext) items.push({ label: 'Play next', icon: ListStart, onSelect: actions.playNext, disabled: actions.playbackDisabled || actions.busy })
  if (actions.addToQueue) items.push({ label: 'Add to queue', icon: ListPlus, onSelect: actions.addToQueue, disabled: actions.playbackDisabled || actions.busy })
  if (actions.addToPlaylist) items.push({ label: 'Add to playlist', icon: ListMusic, onSelect: actions.addToPlaylist })
  if (actions.addToLibrary) items.push({ label: actions.inLibrary ? 'In your library' : 'Add to library', icon: actions.inLibrary ? Check : Plus, onSelect: actions.addToLibrary, disabled: actions.inLibrary || actions.busy })
  if (actions.toggleFavorite) items.push({ label: actions.favorite ? 'Remove from favourites' : 'Add to favourites', icon: Heart, onSelect: actions.toggleFavorite, disabled: actions.busy })
  if (actions.share) items.push({ label: actions.shareLabel ?? "Share", icon: Share2, onSelect: actions.share, disabled: actions.busy })
  return items
}
